import { NodeData } from './prismic-to-html-string';

export const checkForAnchorTagLink = (link: NodeData) => {
  return link?.link_type === 'Web' && (link?.url?.startsWith('https://#') || link?.url?.startsWith('#'));
};
